// extracted by mini-css-extract-plugin
export var link = "ButtonLink-module--link--b1978";